var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('new-hero'),_c('selected-work',{ref:"myWork"}),_c('about-me',{ref:"aboutMe"}),_c('contact-me',{ref:"contactMe"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }